<!-- Main application layout -->
<app-layout></app-layout>

<!-- Global dialogs and overlays -->
<p-confirmDialog
  [style]="{ width: '50vw' }"
  [baseZIndex]="10000"
  rejectButtonStyleClass="p-button-text"
  styleClass="vc-dialog-confirm"
></p-confirmDialog>

<app-loading></app-loading>
<p-toast></p-toast>
